export default{
    screen:{
        width:window.innerWidth,
        height:window.innerHeight,
        scale:20
    }//大屏设计宽高
}


// WEBPACK FOOTER //
// ./src/assets/js/ceshi.js